import ModusServiceModel from "../ModusServiceModel";
import LaboratoryClientCollection from "@/collections/modus/LaboratoryClientCollection";
import LaboratoryContactCollection from "@/collections/modus/LaboratoryContactCollection";

export default class LaboratoryModel extends ModusServiceModel {
  modelName() {
    return 'laboratories';
  }
  icon() {
    return 'building';
  }
  defaults() {
    return {
      id: null,
      short_name: null,
      full_name: null,
      address: null,
      city: null,
      province: null,
      postal: null,
      phone: null,
      fax: null,
      email: null,
      website: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      laboratory_clients: {},
      laboratory_contacts: {}
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      short_name: (val) => (this.nullStringMutator(val)),
      full_name: (val) => (this.nullStringMutator(val)),
      address: (val) => (this.nullStringMutator(val)),
      city: (val) => (this.nullStringMutator(val)),
      province: (val) => (this.nullStringMutator(val)),
      postal: (val) => (this.nullStringMutator(val)),
      phone: (val) => (this.nullStringMutator(val)),
      fax: (val) => (this.nullStringMutator(val)),
      email: (val) => (this.nullStringMutator(val)),
      website: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val)),
    }
  }
  validation() {
    return {}
  }
  getLaboratoryClients() {
    return this.getRelatedCollection(new LaboratoryClientCollection(), 'laboratory_clients');
  }
  getLaboratoryContacts() {
    return this.getRelatedCollection(new LaboratoryContactCollection(), 'laboratory_contacts');
  }
}
